import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Loss Adjuster Desk.
 * Contains menu items for compliance and infraction management.
 */
export const investmentMenu: IMenuItem = {
  label: `Investments`,
  icon: 'fa fa-money-bill-trend-up',
  id: 'MID_INVESTMENT_DESK',
  path: 'investment-desk',
  children: [
    { path: `funds`, label: `Funds`, id: 'MID_INVESTMENT_DESK_FUNDS' },
    { path: `limits`, label: `Limits`, id: 'MID_INVESTMENT_DESK_LIMITS' },
  ],
};
